import { rest } from 'msw';

export default [
    rest.post('/batch-print', (req, res, ctx) => {
        if (req.referrer.includes('family-report')) {
            return res(
                ctx.status(401),
                ctx.json({ status: 'failure', message: 'StudentProfileBatchPrint Request Failed To Queue' })
            );
        }
        return res(ctx.json({ status: 'success', message: 'StudentProfileBatchPrint Request Successfully Queued' }));
    }),
];
